import React, {cloneElement} from 'react';
import Link from 'next/link';
import Router from 'next/router';

const NextLink = (props) => {
  const { children } = props;

  const prefetch =
    (!props.as ||
      process.env.NODE_ENV === 'development' ||
      process.env.DEALER_SITE)
      ? false
      : undefined;

  // ONLY change for dealer site
  const regularLink = !!process.env.DEALER_SITE;

  const linkProps = !props.as && props.href
    ? {
        ...props,
        as: props.href
      }
    : props;

  const htmlLinkProps = {
    ...props,
    href: props.as || props.href
  };

  return (
    (props.href && regularLink !== true) ? (
      <Link {...linkProps} prefetch={prefetch}>
        {children}
      </Link>
    ) : (
      <RegularLink {...htmlLinkProps}>
        {children}
      </RegularLink>
    )
  );
};

const RegularLink = (props) => {
  const {
    children,
    href,
    ...restProps
  } = props;

  // ONLY clone anchors, not buttons/components
  if (
    React.isValidElement(children) &&
    children.type === 'a'
  ) {
    return cloneElement(children, {
      href,
      ...restProps
    });
  }

  return (
    <a href={href} {...restProps}>
      {children}
    </a>
  );
};

export default NextLink;